import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine16 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24 11.9998C24 18.6272 18.6276 24 12.0002 24C5.37249 24 0 18.6272 0 11.9998C0 5.37249 5.37249 0 12.0002 0C18.6276 0 24 5.37249 24 11.9998Z",
			fill: "#FF82B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.70593 18.3449V8.35237C5.93172 8.9646 4.70727 9.55878 3.86091 9.93687L2.99725 7.99233C4.32919 7.43422 5.93172 6.58786 7.19225 5.63363H9.40664V18.3449H6.70593ZM15.9581 18.6508C12.4832 18.6508 11.2407 16.2384 11.2407 12.8717C11.2407 8.46024 13.3115 5.29163 17.3802 5.29163C18.1011 5.29163 18.749 5.38145 19.2887 5.50773L18.8925 7.66837C18.5505 7.52405 17.8846 7.36207 17.1465 7.36207C15.3643 7.36207 14.0677 8.78458 13.888 11.341C14.3195 10.9629 15.1478 10.4769 16.5166 10.4769C18.6227 10.4769 20.3154 11.8634 20.3154 14.2397C20.3154 16.7785 18.6227 18.6508 15.9581 18.6508ZM15.7063 12.4756C14.896 12.4756 14.2481 12.7815 13.9955 13.1776C13.8519 13.3937 13.8519 13.8977 13.8519 14.2758C13.8519 15.4822 14.554 16.6525 15.8498 16.6525C17.1104 16.6525 17.7583 15.6262 17.7583 14.528C17.7583 13.3396 16.9661 12.4756 15.7063 12.4756Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine16);
export { ForwardRef as ReactComponent };
